import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const GET_PROVIDER_LOADING = 'GET_PROVIDER_LOADING';
export const GET_PROVIDER_SUCCESS = 'GET_PROVIDER_SUCCESS';
export const GET_PROVIDER_REJECT = 'GET_PROVIDER_REJECT';

//* ACTIONS ------------------------------------------------
export const getProviderLoading = () => ({ type: GET_PROVIDER_LOADING });
export const getProviderSuccess = (payload) => ({ type: GET_PROVIDER_SUCCESS, payload });
export const getProviderReject = (payload) => ({ type: GET_PROVIDER_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const getProviderRequest = async (params = {}, getState) => {
    const options = await withToken({
        method: Methods.GET,
        params,
    }, getState);
    return request(`/Providers/web/GetAllProviders`, options);
};

